module.exports = __webpack_public_path__ + "static/media/shelter_marina_marker.da4f60d9.svg";